import httpClient from "http-client/http-client";

const BASE = "v1/community-portal/account-members";

const normalizePhone = (phone) => String(phone || "").replace(/\D/g, "");

export async function listTeamMembers({ current_page = 1, page_size = 100 } = {}) {
  const { data, errors } = await httpClient.get({
    url: BASE,
    params: { current_page, page_size },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function sendMemberOtp(phoneNumber) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/auth/send-otp",
    body: { phone_number: normalizePhone(phoneNumber), type: "ADD_MEMBER" },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function addMember({ name, phone_number, otp }) {
  const { data, errors } = await httpClient.post({
    url: BASE,
    body: {
      name,
      phone_number: normalizePhone(phone_number),
      otp: String(otp || "").trim(),
    },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function revokeMember(memberId) {
  const { data, errors } = await httpClient.delete({
    url: `${BASE}/${memberId}`,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
